import { kasseClient } from '@/js/helpers/backend-clients';
import {
  displayAxiosError,
  hideLoadingOverlay,
} from '@/js/helpers/utils';
import konstanten from '@/js/konstanten';
import router from '@/router';
import { setFile } from '@/plugins/axios';

export default {
  setErmittlungsstichtag({ commit }, ermittlungsstichtag) {
    commit('SET_ERMITTLUNGSSTICHTAG', ermittlungsstichtag);
  },
  setBaujahr({ commit }, baujahr) {
    const number = parseInt(baujahr);
    commit('SET_BAUJAHR', isNaN(number) ? undefined : number);
  },
  setWohnungsnummer({commit}, wohnungsnummer) {
    commit('SET_WOHNUNGSNUMMER', wohnungsnummer);
  },
  setAnzahlWohneinheiten({commit}, anzahlWohneinheiten) {
    const number = parseInt(anzahlWohneinheiten);
    commit('SET_ANZAHL_WOHNEINHEITEN', isNaN(number) ? undefined : number);
  },
  setAnzahlNutzeinheiten({commit}, anzahlNutzeinheiten) {
    const number = parseInt(anzahlNutzeinheiten);
    commit('SET_ANZAHL_NUTZEINHEITEN', isNaN(number) ? undefined : number);
  },
  setWohnflaeche({commit}, wohnflaeche) {
    const number = parseFloat(wohnflaeche);
    commit('SET_WOHNFLAECHE', isNaN(number) ? undefined : number);
  },
  setNutzflaeche({commit}, nutzflaeche) {
    const number = parseFloat(nutzflaeche);
    commit('SET_NUTZFLAECHE', isNaN(number) ? undefined : number);
  },
  setKernsanierung({ commit }, kernsanierung) {
    commit('SET_KERNSANIERUNG', kernsanierung ? kernsanierung : false);
  },
  setJahrDerKernsanierung({ commit }, jahrDerKernsanierung) {
    const number = parseInt(jahrDerKernsanierung);
    commit('SET_JAHR_DER_KERNSANIERUNG', isNaN(number) ? undefined : number);
  },

  setAussenwaendeModernisierung({ commit }, modernisierung) {
    commit('SET_AUSSENWAENDE_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setAussenwaendeJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_AUSSENWAENDE_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },

  setDachModernisierung({ commit }, modernisierung) {
    commit('SET_DACH_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setDachJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_DACH_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },

  setFensterModernisierung({ commit }, modernisierung) {
    commit('SET_FENSTER_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setFensterJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_FENSTER_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },

  setFussboedenModernisierung({ commit }, modernisierung) {
    commit('SET_FUSSBOEDEN_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setFussboedenJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_FUSSBOEDEN_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },

  setInnenwaendeModernisierung({ commit }, modernisierung) {
    commit('SET_INNENWAENDE_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setInnenwaendeJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_INNENWAENDE_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },

  setDeckenModernisierung({ commit }, modernisierung) {
    commit('SET_DECKEN_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setDeckenJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_DECKEN_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },

  setSanitaerModernisierung({ commit }, modernisierung) {
    commit('SET_SANITAER_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setSanitaerJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_SANITAER_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },

  setHeizungModernisierung({ commit }, modernisierung) {
    commit('SET_HEIZUNG_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setHeizungJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit('SET_HEIZUNG_JAHR_DER_MODERNISIERUNG', isNaN(number) ? undefined : number);
  },

  setTechnischeAusstattungModernisierung({ commit }, modernisierung) {
    commit('SET_TECHNISCHE_AUSSTATTUNG_MODERNISIERUNG', modernisierung ? modernisierung : false);
  },
  setTechnischeAusstattungJahrDerModernisierung({ commit }, jahrDerModernisierung) {
    const number = parseInt(jahrDerModernisierung);
    commit(
      'SET_TECHNISCHE_AUSSTATTUNG_JAHR_DER_MODERNISIERUNG',
      isNaN(number) ? undefined : number,
    );
  },

  setObjektunterlagenGrundriss({ commit }, grundriss) {
    commit('SET_OBJEKTUNTERLAGEN_GRUNDRISS', grundriss);
  },
  setObjektunterlagenZusatzdokumentGrundriss({ commit }, zusatzdokumentGrundriss) {
    commit('SET_OBJEKTUNTERLAGEN_ZUSATZDOKUMENT_GRUNDRISS', zusatzdokumentGrundriss);
  },
  setObjektunterlagenEnergieausweis({ commit }, energieausweis) {
    commit('SET_OBJEKTUNTERLAGEN_ENERGIEAUSWEIS', energieausweis);
  },
  setObjektunterlagenZusatzdokumentEnergieausweis({ commit }, zusatzdokumentEnergieausweis) {
    commit('SET_OBJEKTUNTERLAGEN_ZUSATZDOKUMENT_ENERGIEAUSWEIS', zusatzdokumentEnergieausweis);
  },

  setAnsprechpartnerVorname({ commit }, vorname) {
    commit('SET_ANSPRECHPARTNER_VORNAME', vorname);
  },
  setAnsprechpartnerNachname({ commit }, nachname) {
    commit('SET_ANSPRECHPARTNER_NACHNAME', nachname);
  },
  setAnsprechpartnerTelefon({ commit }, telefon) {
    commit('SET_ANSPRECHPARTNER_TELEFON', telefon);
  },
  setAnsprechpartnerErlaeuterung({ commit }, erlaeuterung) {
    commit('SET_ANSPRECHPARTNER_ERLAEUTERUNG', erlaeuterung);
  },
  setAlternateAnsprechpartnerName({ commit }, alternateName) {
    commit('SET_ALTERNATE_ANSPRECHPARTNER_NAME', alternateName);
  },
  setAlternateAnsprechpartnerFunction({ commit }, alternateFunction) {
    commit('SET_ALTERNATE_ANSPRECHPARTNER_FUNCTION', alternateFunction);
  },
  setAlternateAnsprechpartnerTelefon({ commit }, alternateTelefon) {
    commit('SET_ALTERNATE_ANSPRECHPARTNER_TELEFON', alternateTelefon);
  },
  setAlternateAnsprechpartnerEmail({ commit }, alternateEmail) {
    commit('SET_ALTERNATE_ANSPRECHPARTNER_EMAIL', alternateEmail);
  },

  setDefaultRechnungName1({ commit }, name1) {
    commit('SET_DEFAULT_RECHNUNG_NAME1', name1);
  },
  setDefaultRechnungName2({ commit }, name2) {
    commit('SET_DEFAULT_RECHNUNG_NAME2', name2);
  },
  setDefaultRechnungPlz({ commit }, plz) {
    commit('SET_DEFAULT_RECHNUNG_PLZ', plz);
  },
  setDefaultRechnungOrt({ commit }, ort) {
    commit('SET_DEFAULT_RECHNUNG_ORT', ort);
  },
  setDefaultRechnungStr({ commit }, str) {
    commit('SET_DEFAULT_RECHNUNG_STR', str);
  },
  setDefaultRechnungHnr({ commit }, hnr) {
    commit('SET_DEFAULT_RECHNUNG_HNR', hnr);
  },

  setUseDefaultRechnungData({ commit }, useDefaultRechnungData) {
    commit('SET_USE_DEFAULT_RECHNUNG_DATA', useDefaultRechnungData);
  },
  setAlternativeRechnungName1({ commit }, name1) {
    commit('SET_ALTERNATIVE_RECHNUNG_NAME1', name1);
  },
  setAlternativeRechnungName2({ commit }, name2) {
    commit('SET_ALTERNATIVE_RECHNUNG_NAME2', name2);
  },
  setAlternativeRechnungPlz({ commit }, plz) {
    commit('SET_ALTERNATIVE_RECHNUNG_PLZ', plz);
  },
  setAlternativeRechnungOrt({ commit }, ort) {
    commit('SET_ALTERNATIVE_RECHNUNG_ORT', ort);
  },
  setAlternativeRechnungStr({ commit }, str) {
    commit('SET_ALTERNATIVE_RECHNUNG_STR', str);
  },
  setAlternativeRechnungHnr({ commit }, hnr) {
    commit('SET_ALTERNATIVE_RECHNUNG_HNR', hnr);
  },

  reset({ commit }) {
    commit('RESET_STATE');
  },
  loadObjektbesichtigung({ state, commit, dispatch }, saved) {
    commit('RESET_STATE');
    let unwrap = ({ modernisierung, jahrDerModernisierung }) => ({
      modernisierung,
      jahrDerModernisierung,
    });

    const {
      data: {
        produkt,
        adresse,
        allgemeineAngaben,
        aussenwaende,
        dach,
        fenster,
        fussboeden,
        innenwaende,
        decken,
        sanitaer,
        heizung,
        technischeAusstattung,
        ansprechpartner,
        objektunterlagen,
        alternativeRechnung
      },
    } = saved;
    Object.assign(state.allgemeineAngaben, allgemeineAngaben);
    Object.assign(state.aussenwaende, unwrap(aussenwaende));
    Object.assign(state.dach, unwrap(dach));
    Object.assign(state.fenster, unwrap(fenster));
    Object.assign(state.fussboeden, unwrap(fussboeden));
    Object.assign(state.innenwaende, unwrap(innenwaende));
    Object.assign(state.decken, unwrap(decken));
    Object.assign(state.sanitaer, unwrap(sanitaer));
    Object.assign(state.heizung, unwrap(heizung));
    Object.assign(state.technischeAusstattung, unwrap(technischeAusstattung));
    Object.assign(state.ansprechpartner, ansprechpartner);
    Object.assign(state.defaultRechnung, produkt.defaultRechnung);
    Object.assign(state.alternativeRechnung, alternativeRechnung);
    state.ausSpeicherGeladen = true;

    commit('kasse/UPDATE_WARENKORB_PRODUKTE', [produkt], { root: true });
    commit('address/UPDATE_CURRENT_ADDRESS', adresse, { root: true });
    let promises = [];
    promises.push(
      ...objektunterlagen.map(f => {
        return kasseClient.downloadFile('ndgmfh', f).then(response => {
          setFile(response, 'ndgmfh', f, undefined, d => {
            state.objektunterlagen[konstanten.IMAGE_MAP.objektunterlagen[f]] = d;
          });
        });
      }),
    );
      Promise.all(promises).then(_ => {
        router.push('/konfiguration/ndg');
      })
      .catch(error => displayAxiosError(error))
      .finally(() => hideLoadingOverlay());
  },
};
